import { inject, Injectable } from '@angular/core'
import {
  HttpContext,
  HttpContextToken,
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http'
import { Observable } from 'rxjs'
import { tap } from 'rxjs/operators'

import { AuthError } from '@core/auth/models/auth.models'
import { ToastService } from '@core/services/toast/toast.service'
import { environment } from '@env'
import { EnvType } from '@mediacoach/ui'
import { TranslateService } from '@ngx-translate/core'

const NO_TOAST_ON_FAILURE = new HttpContextToken<boolean>(() => false)

export function noToastOnFailure(hideToast: boolean) {
  return new HttpContext().set(NO_TOAST_ON_FAILURE, hideToast)
}

const ERROR_BLACKLIST = [AuthError.UserDisallowed, AuthError.InvalidGrant, AuthError.InvalidRequest]

@Injectable()
export class AlertsInterceptor implements HttpInterceptor {
  private readonly _toast: ToastService = inject(ToastService)
  private readonly _translate: TranslateService = inject(TranslateService)

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap(null, (error) => {
        if (error instanceof HttpErrorResponse) {
          const errorResponse = error.error || {}
          if (
            error.status > 0 &&
            !ERROR_BLACKLIST.includes(errorResponse.error) &&
            !request.context.get(NO_TOAST_ON_FAILURE) &&
            environment.envType !== EnvType.Pr
          ) {
            this._toast.create({
              color: 'danger',
              message: this._translate.instant('MTR_PROFILE_UPDATE_ERROR'),
              duration: 2000
            })
          }
        }
      })
    )
  }
}
